module.exports = __webpack_public_path__ + "static/media/thanks.42da9012.png";